<template>
  <h2 class="text-display2 pb-4 pt-12"><slot /></h2>
</template>
